const HeroSection = ({ t, lang, data }) => {
    return (
    <section className="py-5 position-relative overflow-hidden">
        <div className="container py-4">
            <div className="text-center mb-5 pb-4" data-aos="zoom-in">
                <h2 className="fw-bold display-5 mb-3">
                    {lang === "en" ? "Our Impact in Numbers" : "تأثيرنا بالأرقام"}
                </h2>
                <p className="text-muted fs-5">
                    {lang === "en"
                        ? "Proven results that speak for themselves"
                        : "نتائج مثبتة تتحدث عن نفسها"}
                </p>
            </div>

            <div className="row g-4 justify-content-center">
                {[
                    {
                        num: "200+",
                        icon: "ri-trophy-line",
                        title_en: "Projects Completed",
                        title_ar: "مشروع مكتمل",
                        desc_en: "Successfully delivered across industries",
                        desc_ar: "تم تسليمها بنجاح عبر الصناعات",
                    },
                    {
                        num: "150+",
                        icon: "ri-user-smile-line",
                        title_en: "Happy Clients",
                        title_ar: "عميل سعيد",
                        desc_en: "Building lasting partnerships",
                        desc_ar: "بناء شراكات دائمة",
                    },
                    {
                        num: "25+",
                        icon: "ri-global-line",
                        title_en: "Countries Served",
                        title_ar: "دولة نخدمها",
                        desc_en: "Global reach and expertise",
                        desc_ar: "انتشار وخبرة عالمية",
                    },
                    {
                        num: "10+",
                        icon: "ri-award-line",
                        title_en: "Years Experience",
                        title_ar: "سنوات خبرة",
                        desc_en: "Industry leadership and innovation",
                        desc_ar: "قيادة وابتكار في الصناعة",
                    },
                ].map((s, i) => (
                    <div className="col-6 col-lg-3 col-md-6 number-index mt-1 mt-sm-3" key={i} data-aos="fade-up">
                        <div className="text-center  py-md-4 h-100">
                            <div className="mb-4 position-relative d-inline-block">
                                <div
                                    className="tob-numb  position-relative d-inline-flex align-items-center justify-content-center"
                                    style={{ width: 140, height: 140 }}
                                >
                                    <div className="position-absolute w-100 h-100 rounded-circle border border-3 border-primary opacity-25"></div>
                                    <div className="position-absolute rounded-circle bg-primary opacity-10 cont-icon-numb" style={{ width: 110, height: 110 }} >
                                        <i className={`${s.icon} position-relative icon-numb`} style={{ fontSize: "70px" }}></i>
                                    </div>
                                    
                                </div>
                            </div>

                            <h2 className="fw-bold display-4 text-primary mb-3">{s.num}</h2>
                            <h5 className="fw-bold mb-2">
                                {lang === "en" ? s.title_en : s.title_ar}
                            </h5>
                            <p className="text-muted small">
                                {lang === "en" ? s.desc_en : s.desc_ar}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
};

export default HeroSection;